import { config } from "src/configs/config";
import datos from "src/services/datos";
import Swal from "sweetalert2";
import esArray from "src/general_components/functionEsArray";

var myHeaders = new Headers();
myHeaders.append("Authorization", config.authToken);
myHeaders.append("Content-Type", "application/json");

export const getUbicaciones = async (auth) => {
    const ubicaciones = new datos('ubicaciones')
    const response = await ubicaciones.get()
    return response.wsResponse.ubicaciones
};

export const getDepositos = async (id_dep) => {
    const deposito = new datos('owner_localizaciones')
    deposito.addCondition('owner_localizaciones', 'id', id_dep, ' = ');
    const response = await deposito.get()

    const res = response.wsResponse.owner_localizaciones;
    // Si es un array se mantiene como estaba
    if (Array.isArray(res)) {
        var arr = res;
        // Si no es un array... primero se verifica que tenga valores ... si no los tiene
    } else if (typeof res === 'undefined') { // se pasa un array vacio
        arr = [];
    } else { // si trae un solo elemento , es un objeto
        arr = [res]; // se lo convierte a array
    }


    return arr
};

export const getUbicacionesFiltrado = async (data) => {
    const Objubicaciones = new datos('ubicaciones')
    Objubicaciones.addCondition('ubicaciones', 'id', 0, '>');
    // Se añaden condiciones dependiendo de las coordenadas que se ingresen
    if (typeof data.idDep !== 'undefined') {
        Objubicaciones.addCondition('ubicaciones', 'id_owner_localizaciones', data.idDep, ' = ');
    }
    if (typeof data.idSector !== 'undefined') {
        Objubicaciones.addCondition('ubicaciones', 'sector', data.idSector, ' = ');
    }
    if (typeof data.idModulo !== 'undefined') {
        Objubicaciones.addCondition('ubicaciones', 'modulo', data.idModulo, ' = ');
    }
    if (typeof data.idEstante !== 'undefined') {
        Objubicaciones.addCondition('ubicaciones', 'estante', data.idEstante, ' = ');
    }
    if (typeof data.idPosicion !== 'undefined') {
        Objubicaciones.addCondition('ubicaciones', 'posicion', data.idPosicion, ' = ');
    }
    if (typeof data.idEstiba !== 'undefined') {
        Objubicaciones.addCondition('ubicaciones', 'estibe', data.idEstiba, ' = ');
    }
    if (typeof data.idProfundidad !== 'undefined') {
        Objubicaciones.addCondition('ubicaciones', 'profundidad', data.idProfundidad, ' = ');
    }
    Objubicaciones.join("estados_ubicaciones", "id", "id_estados_ubicaciones", "=");

    const response = await Objubicaciones.get();
    const res = response.wsResponse.ubicaciones;


    // Si es un array se mantiene como estaba
    if (Array.isArray(res)) {
        var arr = res;
        // Si no es un array... primero se verifica que tenga valores ... si no los tiene
    } else if (typeof res === 'undefined') { // se pasa un array vacio
        arr = [];
    } else { // si trae un solo elemento , es un objeto
        arr = [res]; // se lo convierte a array
    }

    return arr;
};

function getLatestCajaId(cajasUbicaciones) {
    if (!cajasUbicaciones) return "-";

    // Si viene como objeto directo
    if (!Array.isArray(cajasUbicaciones)) {
        return cajasUbicaciones.id_cajas ?? "";
    }

    // Si viene array: elegir el movimiento más reciente
    let latest = null;

    cajasUbicaciones.forEach((item) => {
        if (!latest) {
            latest = item;
            return;
        }

        const idA = parseInt(item.id, 10);
        const idB = parseInt(latest.id, 10);

        // 1) Comparamos ID (más alto = más reciente)
        if (idA > idB) {
            // comparamos fechas

            const dateA = new Date(item.fecha.split("-").reverse().join("-"));
            const dateB = new Date(latest.fecha.split("-").reverse().join("-"));

            if (dateA > dateB) {
                latest = item;
            }
            return;
        }
    });

    return latest?.id_cajas ?? "";
}


export const getUbicacionesPaginated = async (limit, offset, data) => {

    const ubicaciones = new datos('ubicaciones')
    ubicaciones.addCondition('ubicaciones', 'id', 0, '>')

    // Se añaden condiciones dependiendo de las coordenadas que se ingresen
    if (typeof data.id_owner_localizaciones !== 'undefined' && data.id_owner_localizaciones) {
        ubicaciones.addCondition('ubicaciones', 'id_owner_localizaciones', data.id_owner_localizaciones, ' = ');
    }
    if (typeof data.id_sector !== 'undefined' && data.id_sector) {
        ubicaciones.addCondition('estantes', 'sector', data.id_sector, ' = ');
    }
    if (typeof data.id_modulo !== 'undefined' && data.id_modulo) {
        ubicaciones.addCondition('estantes', 'modulo', data.id_modulo, ' = ');
    }
    if (typeof data.id_estante !== 'undefined' && data.id_estante) {
        ubicaciones.addCondition('estantes', 'estante', data.id_estante, ' = ');
    }
    if (typeof data.id_posicion !== 'undefined' && data.id_posicion) {
        ubicaciones.addCondition('ubicaciones', 'posicion', data.id_posicion, ' = ');
    }
    if (typeof data.id_estibe !== 'undefined' && data.id_estibe) {
        ubicaciones.addCondition('ubicaciones', 'estibe', data.id_estibe, ' = ');
    }
    if (typeof data.id_profundidad !== 'undefined' && data.id_profundidad) {
        ubicaciones.addCondition('ubicaciones', 'profundidad', data.id_profundidad, ' = ');
    }
    if (typeof data.id_tipo_cajas !== 'undefined' && data.id_tipo_cajas) {
        const tipoCajasIds = String(data.id_tipo_cajas);
        if (tipoCajasIds.includes(',')) {
            ubicaciones.addCondition('estantes', 'id_tipo_cajas', `(${tipoCajasIds})`, ' IN ');
        } else {
            ubicaciones.addCondition('estantes', 'id_tipo_cajas', tipoCajasIds, ' = ');
        }
    }
    if (typeof data.id_tipo_estante !== 'undefined' && data.id_tipo_estante) {
        ubicaciones.addCondition('estantes', 'id_tipo_estante', data.id_tipo_estante, ' = ');
    }

    if (Boolean(data.id_estado_ubicaciones)) {
        const estadoIds = String(data.id_estado_ubicaciones);
        if (estadoIds.includes(',')) {
            ubicaciones.addCondition('estados_ubicaciones', 'id', `(${estadoIds})`, ' IN ');
        } else {
            ubicaciones.addCondition('estados_ubicaciones', 'id', estadoIds, ' = ');
        }
    }
    ubicaciones.join("estados_ubicaciones", "id", "id_estados_ubicaciones", "=");
    ubicaciones.join("estantes", "id", "id_estante", "=");
    ubicaciones.innerJoinTables('tipo_estante', 'estantes', "id", "id_tipo_estante", "=")
    if (Boolean(data.incluir_id_cajas)){
        ubicaciones.join("cajas_ubicaciones", "id_ubicaciones", "id", "=");
    }
    // ubicaciones.innerJoinTables('tipo_cajas', 'estantes', "id", "id_tipo_cajas", "=")
    ubicaciones.addLimitCondition(limit, offset)
    const response = await ubicaciones.get()
    /* devuelvo un objeto de respuesta generica  CON ELEMENTO DE "TOTAL_RECORDS" PARA USARSE CON PAGINACION*/

    let result = {}
    let ubicacionesList = [];
    if (!response.wsResponse.empty) {
        if (response.wsResponse.ubicaciones) {
            ubicacionesList = esArray(response.wsResponse.ubicaciones)
            for (let i = 0; i < ubicacionesList.length; i++) {
                ubicacionesList[i].estado = ubicacionesList[i]?.relations?.estados_ubicaciones?.detalle;
                ubicacionesList[i].estante = ubicacionesList[i]?.relations?.estantes?.estante;
                ubicacionesList[i].sector = ubicacionesList[i]?.relations?.estantes?.sector;
                ubicacionesList[i].modulo = ubicacionesList[i]?.relations?.estantes?.modulo;
                if (Boolean(data.incluir_id_cajas)){
                    ubicacionesList[i].id_caja = ubicacionesList[i].id_estados_ubicaciones !== '1' && ubicacionesList[i].id_estados_ubicaciones !== '5'? 
                    getLatestCajaId(ubicacionesList[i]?.relations?.cajas_ubicaciones) : "-";
                }
            }
        }

        result = {
            data: ubicacionesList,
            total_records: response.wsResponse.total_records ? response.wsResponse.total_records : 0
        }
        return result

    }
};




export const getUbicacionesSummary = async (data) => {
    const ubicaciones = new datos('ubicaciones');
    ubicaciones.addCondition('ubicaciones', 'id', 0, '>');

    if (data.id_owner_localizaciones) ubicaciones.addCondition('ubicaciones', 'id_owner_localizaciones', data.id_owner_localizaciones, ' = ');
    if (data.id_sector) ubicaciones.addCondition('estantes', 'sector', data.id_sector, ' = ');
    if (data.id_modulo) ubicaciones.addCondition('estantes', 'modulo', data.id_modulo, ' = ');
    if (data.id_estante) ubicaciones.addCondition('estantes', 'estante', data.id_estante, ' = ');
    if (data.id_posicion) ubicaciones.addCondition('ubicaciones', 'posicion', data.id_posicion, ' = ');
    if (data.id_estibe) ubicaciones.addCondition('ubicaciones', 'estibe', data.id_estibe, ' = ');
    if (data.id_profundidad) ubicaciones.addCondition('ubicaciones', 'profundidad', data.id_profundidad, ' = ');

    if (data.id_tipo_cajas) {
        const ids = String(data.id_tipo_cajas);
        ubicaciones.addCondition('estantes', 'id_tipo_cajas', ids.includes(',') ? `(${ids})` : ids, ids.includes(',') ? ' IN ' : ' = ');
    }
    if (data.id_tipo_estante) ubicaciones.addCondition('estantes', 'id_tipo_estante', data.id_tipo_estante, ' = ');
    if (data.id_estado_ubicaciones) {
        const ids = String(data.id_estado_ubicaciones);
        ubicaciones.addCondition('estados_ubicaciones', 'id', ids.includes(',') ? `(${ids})` : ids, ids.includes(',') ? ' IN ' : ' = ');
    }

    ubicaciones.join("estados_ubicaciones", "id", "id_estados_ubicaciones", "=");
    ubicaciones.join("estantes", "id", "id_estante", "=");
    ubicaciones.innerJoinTables('tipo_estante', 'estantes', "id", "id_tipo_estante", "=");

    const response = await ubicaciones.get();
    if (response.wsResponse.empty) return { estados: {}, tipo_cajas: {}, tipo_estante: {}, total: 0 };

    const list = esArray(response.wsResponse.ubicaciones || []);

    const estados = {};
    const tipo_cajas = {};
    const tipo_estante = {};

    list.forEach(item => {
        const estado = item.relations?.estados_ubicaciones?.detalle || 'Sin Estado';
        const tc = item.relations?.estantes?.id_tipo_cajas || null;
        const teNombre = item.relations?.tipo_estante?.nombre || item.relations?.estantes?.relations?.tipo_estante?.nombre || null;
        const teId = item.relations?.estantes?.id_tipo_estante || null;
        const te = teNombre || teId || 'Sin Tipo';

        estados[estado] = (estados[estado] || 0) + 1;
        if (tc) tipo_cajas[tc] = (tipo_cajas[tc] || 0) + 1;
        tipo_estante[te] = (tipo_estante[te] || 0) + 1;
    });

    return { estados, tipo_cajas, tipo_estante, total: list.length };
};

export const postUbicaciones = async (ubicacion) => {

    const ubicaciones = new datos('ubicaciones')
    const response = ubicaciones.createUbicaciones(ubicacion)
    response.then(value => {
        if (value.status === 'false') {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: value.message
            });
        } else {
            Swal.fire({
                icon: "success",
                title: "Genial!!!",
                text: "Se crearon " + value.wsResponse.cantidad_ubicaciones + " ubicaciones nuevas"
            });
        }
    })

    return response;
};